import { IconProps } from "./HomeIcon";

const JobIcon = ({ color = "#999999" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <mask id="path-1-inside-1_1995_18102" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83685 0C5.22466 0 4.72839 0.496277 4.72839 1.10846V7.01932L0.300319 14.689C-0.552976 16.1669 0.513642 18.0144 2.22023 18.0144H12.7798C14.4864 18.0144 15.553 16.1669 14.6997 14.689L10.2707 7.01775V1.10846C10.2707 0.496276 9.77443 0 9.16224 0H5.83685Z"
        />
      </mask>
      <path
        d="M4.72839 7.01932L6.16832 7.85067L6.39108 7.46484V7.01932H4.72839ZM0.300319 14.689L1.74026 15.5203H1.74026L0.300319 14.689ZM14.6997 14.689L16.1396 13.8576L14.6997 14.689ZM10.2707 7.01775H8.60801V7.46327L8.83077 7.8491L10.2707 7.01775ZM6.39108 1.10846C6.39108 1.41456 6.14295 1.66269 5.83685 1.66269V-1.66269C4.30638 -1.66269 3.06569 -0.422002 3.06569 1.10846H6.39108ZM6.39108 7.01932V1.10846H3.06569V7.01932H6.39108ZM1.74026 15.5203L6.16832 7.85067L3.28845 6.18797L-1.13962 13.8576L1.74026 15.5203ZM2.22023 16.3517C1.79359 16.3517 1.52693 15.8898 1.74026 15.5203L-1.13962 13.8576C-2.63288 16.444 -0.766303 19.677 2.22023 19.677V16.3517ZM12.7798 16.3517H2.22023V19.677H12.7798V16.3517ZM13.2597 15.5203C13.4731 15.8898 13.2064 16.3517 12.7798 16.3517V19.677C15.7663 19.677 17.6329 16.444 16.1396 13.8576L13.2597 15.5203ZM8.83077 7.8491L13.2597 15.5203L16.1396 13.8576L11.7106 6.1864L8.83077 7.8491ZM8.60801 1.10846V7.01775H11.9334V1.10846H8.60801ZM9.16224 1.66269C8.85615 1.66269 8.60801 1.41456 8.60801 1.10846H11.9334C11.9334 -0.422008 10.6927 -1.66269 9.16224 -1.66269V1.66269ZM5.83685 1.66269H9.16224V-1.66269H5.83685V1.66269Z"
        fill={color}
        mask="url(#path-1-inside-1_1995_18102)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3252 0.831348C3.3252 0.372207 3.60878 0 3.9586 0H11.5595C11.9093 0 12.1929 0.372207 12.1929 0.831348C12.1929 1.29049 11.9093 1.6627 11.5595 1.6627H3.9586C3.60878 1.6627 3.3252 1.29049 3.3252 0.831348Z"
        fill={color}
      />
      <path d="M14 16.5L11.5 11H4L1 16.5H14Z" fill={color} />
    </svg>
  );
};

export default JobIcon;
